import { useCallback } from 'react';
import { useRouter } from '@tanstack/react-router';

const useNavigateBack = (): () => void => {
    const router = useRouter();

    return useCallback(() => {
        router.history.back();
    }, [router.history]);
}

export default useNavigateBack;